export const plural = {
    news: 'Новости',
    gof: 'Новости GoF',
    commercial: 'Коммерция',
    articless: 'Статьи',
    feat: 'Лонгриды',
    review: 'Обзоры',
    preview: 'Превью',
    secret: 'Секреты',
    hard: 'Железо и софт',
    industry: 'Игровая индустрия',
    alabuga: 'Алабуга',
    'gta-vi': 'GTA VI',
    videos: 'Трейлеры',
    canonical: 'Канонические страницы',
};

export const feedRest = {
    news: 'news',
    commercial: 'commercial',
    feat: 'articles/feat',
    review: 'articles/review',
    preview: 'articles/preview',
    secret: 'articles/secret',
    hard: 'articles/hard',
    industry: 'index',
    videos: 'videos',
};
